(ns common.endpoints.lp-portal.model)

(def fund-reports-request
  [:map
   [:fund-id pos-int?]])

(def master-fund
  [:map
   [:db/id int?]
   [:fund/name {:optional true} [:maybe string?]]])

(def fund-reports-response
  [:map
   [:body
    [:map
     [:reports
      [:sequential
       [:map
        [:db/id int?]
        [:lp-report/title {:optional true} [:maybe string?]]
        [:lp-report/step {:optional true} [:maybe keyword?]]]]]
     ;; The discontinuation state. The blockers are only for a reporting admin.
     [:reporting-discontinued? {:optional true} boolean?]
     [:unfinished-reports? {:optional true} boolean?]
     [:blocking-master-funds {:optional true} [:sequential master-fund]]
     [:feeder-master-funds {:optional true} [:sequential master-fund]]]]])

(def discontinue-fund-reporting-request
  [:map {:closed true}
   [:fund-id pos-int?]])

(def discontinue-fund-reporting-response
  [:map
   [:body
    [:map
     [:fund-id pos-int?]
     [:archived-report-ids [:sequential int?]]]]])
